import React from 'react'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import HandshakeIcon from '@mui/icons-material/Handshake';
import StarsIcon from '@mui/icons-material/Stars';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import GroupIcon from '@mui/icons-material/Group';
import HubIcon from '@mui/icons-material/Hub';

export default function StatsSection() {
    
  const stats = [
    { value: "₹10L to ₹1000Cr+",  label: "Deals", icon: <LocalOfferIcon style={{color:'white'}}/> },
    { value: "Multi-sector",  label: "Expertise", icon: <GroupIcon style={{color:'white'}}/>  },
    { value: "Strong Lender", label: "Network", icon: <HubIcon style={{color:'white'}}/>  },
    { value: "End-to-End",  label: "Execution", icon: <HandshakeIcon style={{color:'white'}}/>  },
  ];
  return (
    
      <section className="pt-20">
      <div
       
        className="max-w-7xl mx-auto px-4 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6"
      >
        {stats.map((item, index) => (
          <div key={index} className="flex items-center gap-5">

            {/* Icon Box */}
            <div className="bg-dark-gold p-2 rounded-full"> <span className='text-red'>{item.icon}</span></div>

            {/* Counter */}
            <div className='flex-col'>
            <h2 className="text-2xl sm:text-3xl  text-white">
              
                {/* <CountUp
                  start={0}
                  end={item.value}
                  duration={2}
                /> */}
              {item.label}
              {/* {item.suffix} */}
            </h2>

            {/* Label */}
            <p className="text-sm text-gray-300">{item.value}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
    
  )
}
